import { Md5 } from 'ts-md5'

export const md5 = (obj: any): string => {
  return Md5.hashStr(JSON.stringify(obj)) as string
}
